<template>
  <div class="layout-wrap">
      <layout-menu></layout-menu>
      <div>
        <router-view :key="key"></router-view>
      </div>
      <layout-footer></layout-footer>
  </div>
</template>

<script>
import layoutMenu from "@/components/layout/menu2"
import layoutFooter from "@/components/layout/footer"
export default {
    components:{
      layoutMenu,
      layoutFooter
    },
    computed:{
        key() {
				    return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
			  },
    }
}
</script>
<style lang="scss"></style>
